import styled from "styled-components";

export const ListVehiclesGrid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;

	p {
		margin: 0;
	}
`;
